export default {
  GET_CALENDAR_EVENTS: (state) => {
    return state.calendarItems
  },
  GET_NEWS: (state) => {
    return state.newsItems
  },
  GET_INSTRUCTORS: (state) => {
    return state.instructorsItem
  },
  GET_STUDENTS: (state) => {
    return state.studentsItem
  },
  GET_CLASSES: (state) => {
    return state.classItems
  },
  GET_POSTS: (state) => {
    return state.posts
  },
  GET_FILES: (state) => {
    return state.files
  },
  GET_ASSIGNMENTS: (state) => {
    return state.assignments
  },
}


// WEBPACK FOOTER //
// ./src/store/Admin/getters.js